import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';
import { ShieldCheck } from '@phosphor-icons/react';

export default function SetupAdmin() {
  const [loginId, setLoginId] = useState('admin');
  const [password, setPassword] = useState('admin1234567');
  const [loading, setLoading] = useState(false);
  const { setupAdmin } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loginId.trim().length < 3) {
      toast.error('Login ID minimal 3 karakter');
      return;
    }
    if (password.length < 8) {
      toast.error('Password minimal 8 karakter');
      return;
    }
    setLoading(true);
    try {
      const { error } = await setupAdmin(loginId.trim(), password);
      if (error) throw error;
      toast.success('Akun admin berhasil dibuat');
      navigate('/admin');
    } catch (error) {
      toast.error(error.message || 'Gagal membuat admin');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4" data-testid="setup-admin-page">
      <div className="w-full max-w-md">
        <div className="bg-white border border-zinc-300 rounded-2xl p-8 shadow-lg">
          <div className="flex items-center gap-3 mb-4">
            <ShieldCheck size={32} weight="bold" className="text-red-600" />
            <h1 className="text-xl sm:text-2xl font-black uppercase tracking-widest text-zinc-900" style={{ fontFamily: 'Chivo' }}>
              SETUP ADMIN
            </h1>
          </div>
          <p className="text-xs font-mono text-zinc-600 leading-relaxed mb-6">
            Belum ada akun administrator. Buat akun admin sekali ini untuk mengelola seluruh user customer. Setelah dibuat, halaman ini tidak akan muncul lagi.
          </p>

          <form onSubmit={handleSubmit} className="space-y-5" data-testid="setup-admin-form">
            <div>
              <label className="text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 block mb-2">Login ID Admin</label>
              <input
                type="text"
                value={loginId}
                onChange={(e) => setLoginId(e.target.value)}
                className="w-full bg-white border border-zinc-300 rounded-lg p-3 text-zinc-900 font-mono focus:border-red-500 focus:ring-1 focus:ring-red-500 focus:outline-none"
                required
                data-testid="setup-login-id"
              />
            </div>
            <div>
              <label className="text-xs font-mono uppercase tracking-[0.2em] text-zinc-500 block mb-2">Password</label>
              <input
                type="text"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-white border border-zinc-300 rounded-lg p-3 text-zinc-900 font-mono focus:border-red-500 focus:ring-1 focus:ring-red-500 focus:outline-none"
                required
                data-testid="setup-password"
              />
              <p className="text-[10px] font-mono text-zinc-500 mt-1">Minimal 8 karakter. Simpan password ini di tempat aman.</p>
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-red-600 hover:bg-red-700 text-white font-mono uppercase text-xs tracking-wider py-3 px-6 rounded-lg shadow-sm transition-colors disabled:opacity-50"
              data-testid="setup-submit"
            >
              {loading ? 'MEMBUAT...' : 'BUAT ADMIN'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
